import React, { useEffect, useRef, useState } from 'react';
import './WidgetContainer.scss';
import PropTypes from 'prop-types';
import { getBandwithValueInMbps, getFromSessionStorage, getOmniWidgetBaseURL, trackAnalytics } from 'common/utils/app.utils';
import { FEASIBILITY_RESPONSE, FEASIBILITY_STATUS_UNAUTH } from 'home/common/constants/constants';
import { getCurrentLead } from 'tokenGeneration/lead.util';
import { trackGTM } from 'app-layout/utils';
import { MODULE_ID } from 'tokenGeneration/constant';

let lastHeartBeatTimestamp = 0;
let widgetLoadStartTime;
const HEARTBEAT_INTERVAL_TIMEOUT = 6000;
let HB_PIXEL_FIRED = false;
let widgetLoadTime = new Date().getTime();
let defaultUrl = getOmniWidgetBaseURL();

/**
 * This is a popup component to render the widget
 * @class
 * @memberof module:CAT
 * @param {WidgetPopup~propTypes} props
 * @returns {ReactElement}
 */
const WidgetPopup = (props) => {
  //State properties
  const [widgetLoaded, setWidgetLoaded] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const [disableHeartbeat, setDisableHeartbeat] = useState(true);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const widgetFrameRef = useRef(null);
  const [widgetUrl, setWidgetUrl] = useState(defaultUrl);

  const leadData = getCurrentLead?.();

  /**
   * Handles events coming from widget and peforms appropriate actions in response to them.
   * @method
   */
  useEffect(() => {
    widgetLoadStartTime = Date.now();
    // sendLogData({
    // 	data: {
    // 		eventName: loggingEventName.OMNIWIDGET_MOUNTED
    // 	},
    // });

    const eventHandler = (event) => {
      let feasibilityResponse=getFromSessionStorage(MODULE_ID,FEASIBILITY_RESPONSE)
      if (event?.data?.eventName && event?.data?.eventName?.startsWith('WtoC')) {
        switch (event?.data?.eventName) {
          case 'WtoC_PageLoaded':
            // sendLogData({
            // 	data: {
            // 		eventName: loggingEventName.OMNIWIDGET_LOADED_SUCCESS,
            // 		pageloadTime: Date.now() - widgetLoadStartTime,
            // 	},
            // });

            setWidgetLoaded(true);
            setDisableHeartbeat(false);
            resetRetryCount();
            break;
          case 'WtoC_HealthCheck': {
            !widgetLoaded && event?.data?.isLoaded && setWidgetLoaded(true);
            if (!HB_PIXEL_FIRED) {
              HB_PIXEL_FIRED = true;
              // sendLogData({
              //     data: {
              //         eventName: loggingEventName.OMNIWIDGET_HB_RECEIVED,
              //         pageloadTime: Date.now() - widgetLoadStartTime,
              //     },
              // });
            }
            if (event.data?.isError) {
              reloadWidget();
              return;
            }
            lastHeartBeatTimestamp = new Date().getTime();
            break;
          }
          case 'WtoC_ErrorLogged':
            // sendLogData({
            // 	data: {
            // 		eventName: loggingEventName.OMNIWIDGET_ERROR_RECEIVED,
            // 		error: event?.data?.errorLogs?.message,
            // 	},
            // });
            break;
          case 'WtoC_Submitted':
            trackAnalytics({
              eVar9: 'b2b| dedicated internet| home page| feasibility| location access| address details| confirm location',
              prop0: 'b2b| dedicated internet',
              prop14: leadData?.authorizedSignatory?.phoneNumber,
              prop35: leadData?.authorizedSignatory?.companyName,
              prop15: leadData?.authorizedSignatory?.email,
              prop17: leadData?.authorizedSignatory?.firstName,
              prop20: event.data?.userData?.data?.address?.addressString,
              prop22: event.data?.userData?.data?.feasibilityStatus === FEASIBILITY_STATUS_UNAUTH.FEASIBLE ? 'Service Available' : 'Manual Check Required',
              eVar5: feasibilityResponse?.feasibilityId ? 'ql_lead_created':'uql_lead_created',
            });
            props.onAddressSubmit(event.data?.userData);
            trackGTM('confirmLocation', 'forme|internet_leased_line|leadpage');
            
            break;

          case 'WtoC_AddressDetails':
            trackAnalytics({
              eVar9: 'b2b| dedicated internet| home page| feasibility| location access| address details| confirm address',
              prop0: 'b2b| dedicated internet',
              prop14: leadData?.authorizedSignatory?.phoneNumber,
              prop35: leadData?.authorizedSignatory?.companyName,
              prop15: leadData?.authorizedSignatory?.email,
              prop17: leadData?.authorizedSignatory?.firstName,
              prop19: event.data?.userData?.pinCode,
              prop20: event.data?.userData?.feasibilityResponse?.address?.addressString,
              prop22: event.data?.userData?.feasibilityResponse?.feasibilityStatus === FEASIBILITY_STATUS_UNAUTH.FEASIBLE ? 'Service Available' : 'Manual Check Required',
              eVar5: feasibilityResponse?.feasibilityId ? 'ql_lead_created':'uql_lead_created',
            });
            props.onSubmit(event.data?.userData);
            trackGTM('confirmAddress', 'forme|internet_leased_line|leadpage');
            
            break;
          case 'WtoC_CustomEvent':
            if (event?.data?.trigger === 'CHANGE_CITY') {
              trackAnalytics({
                eVar0: 'b2b| dedicated internet| home page| feasibility| location access| address details',
                prop0: 'b2b| dedicated internet',
                prop14: leadData?.authorizedSignatory?.phoneNumber,
                prop35: leadData?.authorizedSignatory?.companyName,
                prop15: leadData?.authorizedSignatory?.email,
                prop17: leadData?.authorizedSignatory?.firstName,
                eVar5: feasibilityResponse?.feasibilityId ? 'ql_lead_created':'uql_lead_created',
              });

              props.onCityChange({ cityName: event.data?.userData?.city_value });

              if (event.data?.userData?.free_text === 'LOCATE_ME') {
                trackAnalytics({
                  eVar9: 'b2b| dedicated internet| home page| feasibility| location access| allow access',
                  prop0: 'b2b| dedicated internet',
                  prop14: leadData?.authorizedSignatory?.phoneNumber,
                  prop35: leadData?.authorizedSignatory?.companyName,
                  prop15: leadData?.authorizedSignatory?.email,
                  prop17: leadData?.authorizedSignatory?.firstName,
                  eVar5: feasibilityResponse?.feasibilityId ? 'ql_lead_created':'uql_lead_created',
                });
              } else if (event.data?.userData?.free_text === 'TEXT_SEARCH') {
                if (event.data?.userData?.screenName === 'CITY_PAGE') {
                  trackAnalytics({
                    eVar9: 'b2b| dedicated internet| home page| feasibility| location access| manual entry',
                    prop0: 'b2b| dedicated internet',
                    prop14: leadData?.authorizedSignatory?.phoneNumber,
                    prop35: leadData?.authorizedSignatory?.companyName,
                    prop15: leadData?.authorizedSignatory?.email,
                    prop17: leadData?.authorizedSignatory?.firstName,
                    eVar5: feasibilityResponse?.feasibilityId ? 'ql_lead_created':'uql_lead_created',
                  });
                } else if (event.data?.userData?.screenName === 'CONFIRM_PAGE') {
                  trackAnalytics({
                    eVar9: 'b2b| dedicated internet| home page| feasibility| location access| address details| search area',
                    prop0: 'b2b| dedicated internet',
                    prop14: leadData?.authorizedSignatory?.phoneNumber,
                    prop35: leadData?.authorizedSignatory?.companyName,
                    prop15: leadData?.authorizedSignatory?.email,
                    prop17: leadData?.authorizedSignatory?.firstName,
                    eVar5: feasibilityResponse?.feasibilityId ? 'ql_lead_created':'uql_lead_created',
                  });
                }
              }
            } else if (event?.data?.trigger === 'RESET_FEASIBILITY') {
              props.onFeasibilityReset();
            }
        }
      }
    };
    window.addEventListener('message', eventHandler);
    return () => {
      window.removeEventListener('message', eventHandler);
    };
  }, []);

  /**
   * Disable heartbeat mechanism when browser window is not visible
   * Reason => When tab is not in view browser slows down timeout operations due to which
   * heartbeats from widget don't reach channel
   * @method
   */
  useEffect(() => {
    const visibilityHandler = function () {
      if (document.hidden) {
        setDisableHeartbeat(true);
      } else {
        setDisableHeartbeat(false);
      }
    };
    window.addEventListener('visibilitychange', visibilityHandler);
    return () => {
      window.removeEventListener('visibilitychange', visibilityHandler);
    };
  }, []);

  /**
   * send requestBandwidth in widget url
   */

  useEffect(() => {
    setWidgetUrl((widgetUrl) => {
      if (props?.requestedBandwidth) {
        let bwValueInMbps = getBandwithValueInMbps(props.requestedBandwidth);
        // handling 1Gbps
        if (bwValueInMbps === 1024) {
          bwValueInMbps = 1000;
        }

        widgetUrl += `&requestedBandwidth=${bwValueInMbps}`;
        return widgetUrl;
      }
    });
  }, [props?.requestedBandwidth]);

  /**
   * Handles retry logic for widget
   * Widget sends heart beat event after every 500ms, If we don't receive heart beat
   * for more than 2 seconds we need to retry loading widget. Maximum 3 retries are allowed and
   * in each retry timeout would increase.
   * @method
   */
  useEffect(() => {
    if (widgetLoaded) {
      retryCount && resetRetryCount();
      return;
    }

    const timerId = setTimeout(() => {
      if (retryCount >= 3) {
        // sendLogData({ data: { eventName: loggingEventName.OMNIWIDGET_LOAD_FAILED, index: retryCount } });
        setShowErrorPopup(true);
        return;
      }
      if (!widgetLoaded) {
        widgetLoadTime = new Date().getTime();
        reloadWidget();
      }
    }, 5000 + retryCount * 2000);

    return () => {
      clearTimeout(timerId);
    };
  }, [retryCount, widgetLoaded]);

  /**
   * Handles heart beat logic for widget. If we do not receive heart beat for 2 seconds
   * We will reload widget inside iframe.
   * @method
   */
  useEffect(() => {
    if (disableHeartbeat) return;

    const intervalId = setInterval(() => {
      const currentTime = new Date().getTime();
      if (currentTime - lastHeartBeatTimestamp > HEARTBEAT_INTERVAL_TIMEOUT) {
        widgetLoadTime = new Date().getTime();
        reloadWidget();
      }
    }, HEARTBEAT_INTERVAL_TIMEOUT);

    return () => {
      clearTimeout(intervalId);
    };
  }, [disableHeartbeat]);

  /**
   * Responsible for reloading widget and resetting associated state properties.
   * @method
   */
  const reloadWidget = () => {
    const iframeDocument = widgetFrameRef.current?.contentWindow?.document;
    const rootDiv = iframeDocument?.getElementById('react-native-web-app');
    const componentsDiv = iframeDocument?.getElementById('components-id');

    //Avoid reloading iframe incase the content inside is properly loaded
    //Would be helpful incase we miss heartbeat or load event from widget
    if (rootDiv && componentsDiv) {
      return;
    }

    // sendLogData({
    // 	data: {
    // 		eventName: loggingEventName.OMNIWIDGET_RELOAD_TRIGERRED,
    //         index: retryCount
    // 	},
    // });
    setWidgetLoaded(false);
    setRetryCount((prevRetryCount) => prevRetryCount + 1);
    if (!disableHeartbeat) setDisableHeartbeat(true);
    widgetLoadStartTime = Date.now();
    sessionStorage.removeItem('persist:omniWidgetPersistedStore');

    setWidgetUrl((widgetUrl) => {
      if (props?.requestedBandwidth) {
        widgetUrl += `&requestedBandwidth=${props.requestedBandwidth}`;
        return widgetUrl;
      }
    });
  };

  /**
   * Responsible for resetting retry count.
   * @method
   */
  const resetRetryCount = () => {
    setRetryCount(0);
  };

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <>
      <div id="widget-mask"></div>
      {/* { showErrorPopup && <ErrorHandler onClick={refreshPage} />} */}
      <iframe allow="geolocation *" id="widget-frame" ref={widgetFrameRef} src={widgetUrl}></iframe>
    </>
  );
};

/**
 * Complete props of Widget Popup.
 * @property {func} onSubmit - Called after receiving additional details for lead
 * @property {func} onAddressSubmit - Called after receiving feasibility response
 * @property {string} selectedCity - City selected by user in safo channel
 */
WidgetPopup.propTypes = {
  onAddressSubmit: PropTypes.func,
  onSubmit: PropTypes.func,
  selectedCity: PropTypes.string,
  onCityChange: PropTypes.func,
  onFeasibilityReset: PropTypes.func
};

export default WidgetPopup;
